import React, { useEffect, useState, useRef } from "react";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { useStoreon } from "storeon/react";
import { v4 as uuidv4 } from "uuid";
import InputGroup from "../inputGroup/InputGroup";
import styles from "./styles.module.scss";
import spareImg from "../../../shared/images/spare.svg";
import hitImg from "../../../shared/images/hit.svg";
import missedFirstImg from "../../../shared/images/missed-first.svg";
import baseImg from "../../../shared/images/base.svg";
import themeStyles from "../../../shared/styles/theme/theme-styles.module.scss";
import { ADD_PLAYER } from "../../../store/players";

const CardLaneScore = (props) => {
  const { bowlingCenterInput, playersPreview, cardStyles } = props;
  const socketUrl = process.env.REACT_APP_WEBSOCKET_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl, {
    onOpen: () => console.log("opened"),
    onClose: () => console.log("closed"),
  });

  const [delay, setDelay] = useState("");
  const [appliedTime, setAppliedTime] = useState(0);

  const defaultLaneThrow = {
    activePlayer: false,
    active_player: false,
    game: 0,
    lane: 0,
    playerHcp: 0,
    playerName: "",
    playerNumber: 0,
    scoreCompletedGames: 0,
    teamHcp: 0,
    teamName: "",
    pins: [],
    scores: [],
    speed: [],
    throws: [],
    player_number: 0,
  };

  const [laneThrow, setLaneThrow] = useState(
    (playersPreview && playersPreview[0]) || defaultLaneThrow
  );
  const [squares] = useState(new Array(12).fill(""));
  const [pins, setPins] = useState(new Array(10).fill(-1));
  const [currentSquare, setCurrentSquare] = useState(0);
  const leaveTimeout = useRef();
  const { dispatch, isHideDelay, players } = useStoreon(
    "players",
    "isHideDelay",
    "scoreCardSettings"
  );

  useEffect(() => {
    if (readyState === ReadyState.OPEN && bowlingCenterInput) {
      sendMessage(
        JSON.stringify({
          id: uuidv4(),
          method: 0,
          params: {
            api_key: apiKey,
          },
        })
      );
    }
  }, [readyState, sendMessage, apiKey, bowlingCenterInput]);

  useEffect(() => {
    if (bowlingCenterInput && bowlingCenterInput.uuid) {
      if (readyState === ReadyState.OPEN) {
        sendMessage(
          JSON.stringify({
            id: uuidv4(),
            method: 1,
            params: {
              channel: `LiveScores:${bowlingCenterInput.uuid}`,
            },
          })
        );
      }
    }
  }, [bowlingCenterInput, readyState, sendMessage]);

  useEffect(() => {
    if (lastMessage && lastMessage.data) {
      const parsedData = JSON.parse(lastMessage.data);
      const result1 =
        parsedData.result &&
        parsedData.result.data &&
        parsedData.result.data.lane === +bowlingCenterInput.lane &&
        (parsedData.result.data.playerNumber ===
          +bowlingCenterInput.playerNumber ||
          parsedData.result.data.playerName === bowlingCenterInput.player) &&
        parsedData.result.data;

      const result2 =
        parsedData.result &&
        parsedData.result.publications &&
        parsedData.result.publications
          .filter((pub) => pub.data && pub.type === 2 && pub.data.lanes)
          .map((x) => x.data.lanes)
          .reduce((acc, lanes) => lanes.forEach((lane) => acc.push(lane)))
          .filter((e) => e.lane === +bowlingCenterInput.lane)
          .find(
            (e) =>
              e.playerNumber === +bowlingCenterInput.playerNumber ||
              e.playerName === bowlingCenterInput.player
          );

      if (result1 || result2) {
        if (leaveTimeout.current) {
          clearTimeout(leaveTimeout.current);
        }
        leaveTimeout.current = setTimeout(() => {
          setLaneThrow(result1 || result2);
          dispatch(ADD_PLAYER, {
            ...(result1 || result2),
            displayName: bowlingCenterInput.displayName,
          });
        }, appliedTime);
      }
    }
  }, [lastMessage, bowlingCenterInput, appliedTime, leaveTimeout, dispatch]);

  useEffect(() => {
    if (
      laneThrow.throws &&
      laneThrow.throws[19] &&
      laneThrow.throws[20] !== ""
    ) {
      laneThrow.throws.splice(20, 0, "");
      laneThrow.pins.splice(20, 0, laneThrow.pins[19]);
    }
    // Same as before but after 9
    if (
      laneThrow.throws &&
      laneThrow.throws[18] &&
      laneThrow.throws[19] !== ""
    ) {
      laneThrow.throws.splice(19, 0, "");
      laneThrow.pins.splice(19, 0, laneThrow.pins[18]);
    }
    setCurrentSquare(
      (laneThrow.throws &&
        Math.round(
          (((laneThrow.throws && laneThrow.throws.length) || 0) + 1) / 2
        )) ||
        1
    );
  }, [laneThrow]);

  useEffect(() => {
    if (currentSquare > Math.round(laneThrow.throws.length / 2)) {
      setPins(new Array(10).fill(1));
    }
    const condition =
      laneThrow.throws.length === 22 &&
      laneThrow.throws[20] !== "X" &&
      laneThrow.throws[20] !== "/" &&
      laneThrow.throws[18] === "X";
    if (
      laneThrow.throws.length &&
      ((laneThrow.throws.length % 2 === 0 && laneThrow.throws.length < 19) ||
        (laneThrow.throws.length === 20 &&
          laneThrow.throws[18] !== "X" &&
          laneThrow.throws[18] !== "/") ||
        condition)
    ) {
      calculate(laneThrow, 1, +condition);
    }
    calculate(laneThrow);
  }, [currentSquare, laneThrow]);

  const isSplit = (pin) => {
    return Math.floor(pin / 1024) === 1;
  };

  const getScore = (laneThrow) => {
    const handicapBool = false;
    const includeCurrentGameTotal = true;
    if (handicapBool) {
      const lane = { ...laneThrow };
      const handicap = lane.teamHcp;

      if (handicap) {
        return (
          laneThrow.scoreCompletedGames +
          (laneThrow.scores &&
            laneThrow.scores.length &&
            laneThrow.scores[laneThrow.scores.length - 1]) +
          handicap * lane.game
        );
      }
    }
    return (
      laneThrow.scoreCompletedGames +
      (includeCurrentGameTotal
        ? laneThrow.scores &&
          laneThrow.scores.length &&
          laneThrow.scores[laneThrow.scores.length - 1]
        : 0)
    );
  };

  const getPin = (pos) => {
    return pins[pos - 1];
  };

  const calculate = (lane, prev = 0, special = 0) => {
    const pins = lane.pins;
    let currentPin = pins[lane.throws.length - 1 - prev - special];
    let pow = 9;

    // Removing modifiers on the pins
    currentPin = currentPin >= 4096 ? currentPin - 4096 : currentPin;
    currentPin = currentPin >= 2048 ? currentPin - 2048 : currentPin;
    currentPin = currentPin > 1024 ? currentPin - 1024 : currentPin;

    // If there is no throw set all the bowls up
    if (isNaN(currentPin)) {
      currentPin = 1024;
    }

    // Set the pin array
    while (pow >= 0) {
      const pinValue = Math.pow(2, pow);

      // 1 for standing bowl, 0 for fallen and 2 for fallen previously

      pins[pow] = currentPin >= pinValue ? 1 : !prev && pins[pow] === 1 ? 2 : 0;
      setPins(pins);

      // If the bowl was up substract from the currentPin
      if (pins[pow] === 1) {
        currentPin -= pinValue;
      }
      pow--;
    }
  };

  const getFirstThrowScore = (lane) => {
    return lane.throws[(currentSquare - 1) * 2];
  };

  const getSecondThrowScore = (lane) => {
    return lane.throws[(currentSquare - 1) * 2 + 1];
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setDelay(value);
  };

  const handleApply = () => {
    setAppliedTime(+delay * 1000);
  };

  const {
    fontColor: throwsColor,
    fontSize: throwsFontSize,
    fontBold: throwsFontWeight,
  } = cardStyles.throwsStyle;

  const {
    fontColor: nameColor,
    fontSize: nameFontSize,
    fontBold: nameFontWeight,
  } = cardStyles.playerName;

  const {
    fontColor: scoreColor,
    fontSize: scoreFontSize,
    fontBold: scoreFontWeight,
  } = cardStyles.totalScore;

  const {
    fontColor: centerColor,
    fontSize: centerFontSize,
    fontBold: centerFontWeight,
  } = cardStyles.bowlingcenter;

  const {
    lowFrameBackground: currentLowFrameBackground,
    topFrameBackground: currentTopFrameBackground,
  } = cardStyles.currentFrame;

  const someStyle = {
    "--throwsColor": throwsColor,
    "--throwsFontSize": throwsFontSize,
    "--throwsFontWeight": throwsFontWeight ? "700" : "normal",
    "--nameColor": nameColor,
    "--nameFontSize": nameFontSize,
    "--nameFontWeight": nameFontWeight ? "700" : "normal",
    "--scoreColor": scoreColor,
    "--scoreFontSize": scoreFontSize,
    "--scoreFontWeight": scoreFontWeight ? "700" : "normal",
    "--centerColor": centerColor,
    "--centerFontSize": centerFontSize,
    "--centerFontWeight": centerFontWeight ? "700" : "normal",
    "--currentLowFrameBackground": currentLowFrameBackground,
    "--currentTopFrameBackground": currentTopFrameBackground,
    "--innerBackground": cardStyles.innerBackground,
    "--scoresContainerBackground": cardStyles.scoresContainerBackground,
    "--framesContainerBackground": cardStyles.framesContainerBackground,
    "--sectionContainerBackground": cardStyles.sectionContainerBackground,
  };

  const playersArr = playersPreview ? playersPreview : players;

  return playersArr && playersArr.length ? (
    <div>
      <div className={styles.laneContainer} style={someStyle}>
        <div className={styles.flexVertically}>
          <div className={styles.laneHeader}>
            <span>{`Lane ${
              (bowlingCenterInput && bowlingCenterInput.lane) || 0
            }`}</span>
            <span className={styles.game}>
              game # {laneThrow && laneThrow.game}
            </span>
          </div>
          <div
            className={`${styles.wrapper} ${styles.active} `}
            //style={showBorder ? someStyle : {}}
          >
            <div className={styles.lanePlayer}>
              <span className={`${styles.turns}`}>
                <span className={styles.turn}>1</span>
                <span className={styles.turn}>2</span>
                <span className={styles.turn}>3</span>
                <span className={styles.turn}>4</span>
                <span className={styles.turn}>5</span>
                <span className={styles.turn}>6</span>
                <span className={styles.turn}>7</span>
                <span className={styles.turn}>8</span>
                <span className={styles.turn}>9</span>
                <span className={styles.turn}>10</span>
              </span>
              <span className={styles.squares}>
                {squares.map((s, index) => (
                  <span
                    className={`${styles.square}  ${
                      laneThrow.throws &&
                      laneThrow.throws.length > index * 2 &&
                      styles.past
                    } ${styles.active} ${
                      index === currentSquare - 1 && styles.current
                    }`}
                    key={index}
                    // style={{
                    //   backgroundColor:
                    //     index === currentSquare - 1 ? topFrame : "",
                    // }}
                  >
                    {(laneThrow.throws &&
                      laneThrow.throws.length &&
                      laneThrow.throws[index * 2] &&
                      laneThrow.throws[index * 2] !== "X" &&
                      index < 9 && (
                        <span className={styles.numbers}>
                          <span
                            className={`${styles.number} ${
                              isSplit(laneThrow.pins[index * 2]) && styles.split
                            }`}
                          >
                            {laneThrow.throws[index * 2]}
                          </span>
                          {laneThrow.throws[index * 2 + 1] !== "/" && (
                            <span
                              className={`${styles.number} ${
                                isSplit(laneThrow.pins[index * 2 + 1]) &&
                                styles.split
                              }`}
                            >
                              {laneThrow.throws[index * 2 + 1]}
                            </span>
                          )}
                          {laneThrow.throws[index * 2 + 1] === "/" && (
                            <span className={styles.number}>
                              <img src={spareImg} alt="" />
                            </span>
                          )}
                        </span>
                      )) ||
                      ""}
                    {(index > 8 && (
                      <div>
                        {laneThrow.throws &&
                          laneThrow.throws[index * 2] !== "/" &&
                          laneThrow.throws[index * 2] !== "X" && (
                            <span
                              className={`${styles.number} ${styles.fixTop} ${
                                isSplit(laneThrow.pins[index * 2]) &&
                                styles.split
                              }`}
                            >
                              {laneThrow.throws[index * 2]}
                            </span>
                          )}
                        {laneThrow.throws &&
                          laneThrow.throws[index * 2] === "/" &&
                          laneThrow.throws[index * 2] !== "X" && (
                            <span className={`${styles.number}`}>
                              <img src={spareImg} alt="" />
                            </span>
                          )}
                      </div>
                    )) ||
                      ""}
                    {(laneThrow.throws &&
                      laneThrow.throws.length &&
                      laneThrow.throws[index * 2] &&
                      laneThrow.throws[index * 2] === "X" && (
                        <span className={styles.strike}>X</span>
                      )) ||
                      ""}
                  </span>
                ))}
              </span>
              <span className={styles.squares}>
                {squares.slice(0, 10).map((s, index) => (
                  <span
                    className={`${styles.square} ${styles.score} ${
                      laneThrow.throws.length > index * 2 && styles.past
                    } ${
                      (index === currentSquare - 1 ||
                        (currentSquare > 9 && index === 9)) &&
                      styles.current
                    }`}
                    // style={{
                    //   backgroundColor:
                    //     index === currentSquare - 1 ||
                    //     (currentSquare > 9 && index === 9)
                    //       ? lowFrame
                    //       : "",
                    // }}
                    key={index}
                  >
                    <span className={styles.numbers}>
                      <span className={styles.scoreNumber}>
                        {laneThrow.scores[index]}
                      </span>
                    </span>
                  </span>
                ))}
              </span>
            </div>
            <div className={`${styles.laneResultWrapper}`}>
              <div
                className={styles.laneResult}
                // style={{ background: inner }}
              >
                <div className={styles.laneResultGraphic}>
                  <div className={styles.row}>
                    <img
                      src={
                        getPin(7) === 1
                          ? hitImg
                          : getPin(7) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                    <img
                      src={
                        getPin(8) === 1
                          ? hitImg
                          : getPin(8) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                    <img
                      src={
                        getPin(9) === 1
                          ? hitImg
                          : getPin(9) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                    <img
                      src={
                        getPin(10) === 1
                          ? hitImg
                          : getPin(10) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                  </div>
                  <div className={styles.row}>
                    <img
                      src={
                        getPin(4) === 1
                          ? hitImg
                          : getPin(4) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                    <img
                      src={
                        getPin(5) === 1
                          ? hitImg
                          : getPin(5) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                    <img
                      src={
                        getPin(6) === 1
                          ? hitImg
                          : getPin(6) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                  </div>
                  <div className={styles.row}>
                    <img
                      src={
                        getPin(2) === 1
                          ? hitImg
                          : getPin(2) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                    <img
                      src={
                        getPin(3) === 1
                          ? hitImg
                          : getPin(3) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                  </div>
                  <div className={`${styles.row} ${styles.bottom}`}>
                    <span className={styles.pointWrapper}>
                      {
                        <span className={styles.points}>
                          {getFirstThrowScore(laneThrow)}
                        </span>
                      }
                    </span>
                    <img
                      src={
                        getPin(1) === 1
                          ? hitImg
                          : getPin(1) === 2
                          ? missedFirstImg
                          : baseImg
                      }
                      alt=""
                    />
                    <span className={styles.pointWrapper}>
                      <span className={styles.points}>
                        {getSecondThrowScore(laneThrow)}
                      </span>
                    </span>
                  </div>
                </div>
                <div className={styles.laneResultText}>
                  <div
                    className={styles.laneResultText1}
                    //style={scoreCardSettings.playerNameStyles}
                  >
                    {(bowlingCenterInput && bowlingCenterInput.displayName) ||
                      (playersPreview && "Player Name")}
                  </div>
                  <div className={styles.laneResultText2}>
                    {(bowlingCenterInput &&
                      bowlingCenterInput.bowlingCenterName) ||
                      (playersPreview && "Bowling Center Name")}
                  </div>
                  <div className={styles.laneResultText4}>
                    <span className={styles.laneResultDescription}>Total</span>
                    {getScore(laneThrow) || 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${styles.delay} ${
          (isHideDelay || playersPreview) && styles.hideDelay
        }`}
      >
        <span>Delay (sec)</span>
        <div style={{ width: "30%" }}>
          <InputGroup
            name="delay"
            leftMargin={false}
            inputValue={delay}
            onChange={handleChange}
          />
        </div>
        <button className={`${themeStyles.btnPrimary}`} onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  ) : null;
};
export default CardLaneScore;
